import { render, staticRenderFns } from "./MRResultsDoc.vue?vue&type=template&id=19862f9a&"
import script from "./MRResultsDoc.vue?vue&type=script&lang=js&"
export * from "./MRResultsDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports